const STORAGE_KEY = 'app_diagnostic_guest_id';

let memoryGuestId = null;

// 8 位随机字符（约 62^8 种组合），足够在单个站点规模下避免碰撞，同时保持标识短小易读
function createGuestId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `guest_${crypto.randomUUID().replace(/-/g, '').slice(0, 8)}`;
  }
  return `guest_${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * 获取（或首次生成并持久化）未登录访客的本地标识。
 * 与登录态无关，存放于 localStorage，跨会话、跨标签页保持不变，
 * 用于在用户未登录时归档诊断日志反馈。
 */
export function getOrCreateGuestId() {
  if (typeof localStorage !== 'undefined') {
    try {
      let id = localStorage.getItem(STORAGE_KEY);
      if (!id) {
        id = createGuestId();
        localStorage.setItem(STORAGE_KEY, id);
      }
      memoryGuestId = id;
      return id;
    } catch (error) {
      // localStorage 不可用（如隐私模式），降级为内存态
    }
  }
  if (!memoryGuestId) {
    memoryGuestId = createGuestId();
  }
  return memoryGuestId;
}
